import { useEffect, useState } from 'react';
import { compensationApi } from '../../../api/compensation.js';
import { hrApi } from '../../../api/hr.js';

const money = (v, c = 'IDR') => (v == null ? '—' : `${c} ${Number(v).toLocaleString('en-US')}`);

export default function Statements() {
  const [items, setItems] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState(null);

  function refresh() {
    setLoading(true);
    Promise.all([compensationApi.listStatements(), hrApi.listEmployees().catch(() => ({ items: [] }))])
      .then(([s, e]) => {
        setItems(s?.items || []);
        setEmployees(e?.items || []);
      })
      .catch((err) => setError(err.response?.data?.message || 'Failed to load'))
      .finally(() => setLoading(false));
  }
  useEffect(refresh, []);

  async function submit(e) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    try {
      await compensationApi.createStatement({ employeeId: fd.get('employeeId'), period: fd.get('period') });
      form.reset();
      setShowForm(false);
      refresh();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to generate statement');
    }
  }

  return (
    <section data-testid="comp-statements-page" data-loading={loading ? 'true' : 'false'}>
      <header className="page-header">
        <div>
          <h1>Total Rewards Statements</h1>
          <p className="muted">{items.length} statements</p>
        </div>
        <button className="btn primary" data-testid="comp-statement-create" onClick={() => setShowForm((s) => !s)}>{showForm ? 'Close' : '+ Generate'}</button>
      </header>

      {error && <div className="alert error" data-testid="comp-statements-error">{error}</div>}

      {showForm && (
        <form onSubmit={submit} className="card form-card grid-form">
          <label>Employee
            <select name="employeeId" data-testid="comp-statement-employee-input" required defaultValue="">
              <option value="" disabled>— select —</option>
              {employees.map((emp) => <option key={emp.id} value={emp.id}>{emp.user_name || emp.employee_code || emp.id}</option>)}
            </select>
          </label>
          <label>Period<input name="period" data-testid="comp-statement-period-input" placeholder="FY2026" required /></label>
          <div className="full actions"><button className="btn primary" type="submit" data-testid="comp-statement-submit">Generate PDF</button></div>
        </form>
      )}

      <div className="card">
        <table className="data-table" data-testid="comp-statement-list">
          <thead><tr><th>Employee</th><th>Period</th><th>Total Rewards</th><th>Generated</th><th>PDF</th></tr></thead>
          <tbody>
            {items.map((s) => {
              const breakdown = typeof s.breakdown === 'string' ? JSON.parse(s.breakdown || '{}') : s.breakdown || {};
              return (
                <tr key={s.id} data-testid={`comp-statement-row-${s.id}`}>
                  <td>{s.employee_name || s.employee_code || s.employee_id}</td>
                  <td>{s.period}</td>
                  <td>{money(breakdown.total, breakdown.currency)}</td>
                  <td>{s.generated_at ? String(s.generated_at).slice(0, 10) : '—'}</td>
                  <td>
                    {s.document_file_url ? (
                      <a href={s.document_file_url} target="_blank" rel="noreferrer" data-testid={`comp-statement-pdf-${s.id}`}>Open PDF</a>
                    ) : '—'}
                  </td>
                </tr>
              );
            })}
            {!loading && items.length === 0 && <tr><td colSpan={5} className="muted">No statements yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
}
